import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("span", {
      style: _normalizeStyle(_ctx.accentStyle)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ]))
}